import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { INJECT_UICORE_BUS } from "../../../lib/utils/consts";
import { Prop } from 'vue-property-decorator';
import { writeClipboard } from "../../../lib/utils";
import { selectText } from "../../../lib/utils/browser/selectText";
import Markdown from "../../../lib/builtin/components/Markdown";
import { VNodes } from "../../../lib/utils/vue/VNodes";
import { get, set } from "lodash-es";
import styles from "./index.module.css";
let OverflowDetect = class OverflowDetect extends Vue {
  constructor() {
    super(...arguments);
    this.isOverflow = false;
  }
  render() {
    const h = arguments[0];
    const slots = this.$scopedSlots.context({
      overflow: this.isOverflow
    });
    const node = get(slots, '[0]');
    if (node) {
      const mouseEnter = async ev => {
        var _ev$target, _this$parent;
        await this.$nextTick();
        const contextWidth = ((_ev$target = ev.target) === null || _ev$target === void 0 ? void 0 : _ev$target.getBoundingClientRect().width) || 0;
        const parentWidth = ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.getBoundingClientRect().width) || Infinity;
        this.isOverflow = contextWidth > parentWidth;
      };
      set(node, ['data', 'on', 'mouseenter'], mouseEnter);
      return [node];
    }
    // 兜底
    // @ts-ignore
    return h(VNodes, {
      "attrs": {
        "vnodes": slots
      }
    });
  }
};
__decorate([Prop()], OverflowDetect.prototype, "parent", void 0);
OverflowDetect = __decorate([Component({
  name: 'OverflowDetect'
})], OverflowDetect);
export { OverflowDetect };
let DataSchemaTree = class DataSchemaTree extends Vue {
  constructor() {
    super(...arguments);
    /** 缓存所有渲染出来的路径 用来实现一键展开根元素 */
    this.pathSet = new Set();
    this.expandedKeys = [];
  }
  renderChildren(ds, parentPath) {
    if (ds.type === 'object' && ds.fields) {
      return ds.fields.map((dataSchema, index) => this.renderTreeNode(dataSchema, `${parentPath}.${dataSchema.id || index}`));
    }
    if (ds.type === 'array' && ds.items) {
      return this.renderTreeNode(ds.items, `${parentPath}[0]`);
    }
    return null;
  }
  handleExpand(path) {
    // 折叠自己
    if (this.expandedKeys.includes(path)) {
      this.expandedKeys.splice(this.expandedKeys.indexOf(path), 1);
    } else if (path === this.rootSchemaId) {
      // 点击根节点全部展开
      this.expandedKeys = Array.from(this.pathSet);
    } else {
      // 普通节点展开
      this.expandedKeys.push(path);
    }
  }
  renderTreeNode(ds, path) {
    const h = this.$createElement;
    this.pathSet.add(path);
    const rawComment = ` ${ds.title || ''} ${ds.description || ''}`;
    const comment = rawComment.replace(/\n/g, ' ');
    const commentMarkdown = `${ds.title || ''}\n\n${ds.description || ''}`.trim();
    const objId = ds.id;
    const objType = ds.type;
    const handleClickCopy = ev => {
      var _ref, _this$uc;
      writeClipboard(ev.target.textContent);
      (_ref = ((_this$uc = this.uc) === null || _this$uc === void 0 ? void 0 : _this$uc.$message) || (this === null || this === void 0 ? void 0 : this.$message)) === null || _ref === void 0 || _ref.success(`已复制${path}`);
      selectText(ev.target);
    };
    const renderObjType = () => {
      if (Array.isArray(ds.enum)) {
        const enumStr = ds.enum.map(enumItem => {
          if (objType === 'string') {
            return `"${enumItem.value}"`;
          }
          return enumItem.value;
        }).join('|');
        return enumStr;
      }
      return objType;
    };
    const renderComment = () => h("span", {
      "class": styles.comment
    }, [comment]);
    const renderCommentMarkdownTooltip = (context, enableTooltip = true) => h("a-tooltip", {
      "attrs": {
        "placement": "left",
        "align": {
          targetOffset: [100, 0]
        },
        "mouseEnterDelay": 0.3,
        "overlayClassName": enableTooltip ? '' : styles.hideTooltip
      }
    }, [h(Markdown, {
      "slot": "title",
      "attrs": {
        "source": commentMarkdown
      }
    }), context]);
    const renderIdAndType = () => h("span", [objId ? h("code", {
      "class": styles.objIdCode,
      "on": {
        "click": handleClickCopy
      }
    }, [objId]) : null, objType && objId ? h("span", [" : "]) : null, objType ? h("code", {
      "class": styles.objTypeCode
    }, [renderObjType()]) : null]);
    return (// disabled用来禁掉antd默认的hover样式
      h("a-tree-node", {
        "key": path,
        "attrs": {
          "selectable": false,
          "disabled": true
        }
      }, [h("div", {
        "slot": "title",
        "on": {
          "click": () => this.handleExpand(path)
        }
      }, [h(OverflowDetect, {
        "attrs": {
          "parent": this.$el
        },
        "scopedSlots": {
          context: ({
            overflow
          }) => {
            const showToolTip = overflow || rawComment.includes('\n');
            return h("span", [path === this.rootSchemaId && this.renderRootTitle(), renderIdAndType(), h("span", {
              "class": [showToolTip && styles.overflowDetect],
              "on": {
                "click": ev => {
                  if (showToolTip) {
                    ev.stopPropagation();
                  }
                }
              }
            }, [renderCommentMarkdownTooltip(renderComment(), overflow)])]);
          }
        }
      })]), this.renderChildren(ds, path)])
    );
  }
  get rootSchemaId() {
    return this.dataSchema.id || '0';
  }
  renderRootTitle() {
    const h = this.$createElement;
    return h("span", {
      "class": styles.rootTitle
    }, [this.rootTitle]);
  }
  render() {
    const h = arguments[0];
    const hasChild = this.dataSchema.type === 'object' && this.dataSchema.fields || this.dataSchema.type === 'array' && this.dataSchema.items;
    const expandRoot = (pathArray, {
      expanded,
      node
    }) => {
      // 点左侧箭头的root一键全展开
      if (node.eventKey === this.rootSchemaId && expanded) {
        this.$nextTick(() => this.expandedKeys = Array.from(this.pathSet));
      }
    };
    return h("a-tree", _mergeJSXProps([{
      "class": ['markdown-body uc-markdown', styles.schemaTree, !hasChild && styles.noChild],
      "attrs": {
        "expandedKeys": this.expandedKeys
      }
    }, {
      "on": {
        'update:expandedKeys': e => this.expandedKeys = e
      }
    }, {
      "on": {
        "expand": expandRoot
      }
    }]), [h("a-icon", {
      "slot": "switcherIcon",
      "attrs": {
        "type": "down"
      }
    }), this.renderTreeNode(this.dataSchema, this.rootSchemaId)]);
  }
};
__decorate([Prop({
  required: true,
  type: Object
})], DataSchemaTree.prototype, "dataSchema", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], DataSchemaTree.prototype, "rootTitle", void 0);
DataSchemaTree = __decorate([Component({
  name: 'DataSchemaTree',
  components: {
    Markdown
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    }
  }
})
/** 通过antd-tree展示DataSchema */], DataSchemaTree);
export { DataSchemaTree };
//# sourceMappingURL=index.js.map
